import baseConfigs from './base';

export default {
  ...baseConfigs,
  apiUrl: 'https://api-dev.auto-design.io',
};
